module.exports = __webpack_public_path__ + "static/media/4-1.8e6dc452.webp";